module.exports = __webpack_public_path__ + "img/joinUs_2.ceae8865.png";